import React from 'react';
export const ConsultationPanel: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="bg-white p-8 sm:p-10 lg:p-12 mt-12 sm:mt-16 w-full max-w-4xl mx-auto text-center" data-id="element-41">
      <h3 className="text-2xl sm:text-3xl font-sans text-[#486878] mb-5 sm:mb-6 font-medium" data-id="element-42">
        Complimentary Consultation
      </h3>
      <p className="text-[#486878] mb-6 sm:mb-8 leading-relaxed text-base sm:text-lg max-w-3xl mx-auto" data-id="element-43">
        Let's chat! I provide a free consultation call where we can get to know
        each other and talk through your wedding goals and vision. You'll have
        the chance to share what matters most to you, and I'll walk you through
        how I can help. From there, we'll figure out which package fits best, or
        create something custom that works for your timeline, budget, and needs.
      </p>
      <button onClick={scrollToContact} className="text-[#486878] underline uppercase tracking-wider text-base font-medium hover:text-[#2c5aa0] hover:no-underline transition-all inline-block min-h-[44px] px-4 flex items-center justify-center mx-auto" data-id="element-44">
        Get in Touch
      </button>
    </div>;
};